const USER_ROLES = {
  ROLE_ADMIN: 'Administrador',
  ROLE_MENU_GDT_LISTAGEM: 'Listagem de Terceiros',
  ROLE_MENU_GDT_FOLHA_PAGTO: 'Folha de Pagamento',
  ROLE_MENU_GDT_ENCARGOS: 'Encargos',
  ROLE_ACTION_GDT_LISTAGEM_EDICAO: 'Gerenciamento de Terceiros',
  ROLE_ACTION_GDT_LISTAGEM_CERTIDOES: 'Listagem de Certidões',
  ROLE_ACTION_GDT_GERENCIAMENTO_CERTIDOES: 'Gerenciamento de Certidões',
  ROLE_ACTION_GDT_LISTAGEM_TRABALHO_ANALOGO: 'Listagem de Trabalho Análogo à Escravidão',
  ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHO_ANALOGO: 'Gerenciamento de Trabalho Análogo à Escravidão',
  ROLE_ACTION_GDT_LISTAGEM_TRABALHADORES_ALOCADOS: 'Listagem de Trabalhadores Alocados',
  ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHADORES_ALOCADOS: 'Gerenciamento de Trabalhadores Alocados',
  ROLE_MENU_GDT_SOLICITACAO_VISUALIZACAO: 'Solicitação de Visualização',
  ROLE_MENU_GDT_SOLICITACAO_GERENCIAMENTO: 'Gerenciamento de Solicitações',
  ROLE_MENU_GDT_ENVIO_VISUALIZACAO: 'Envio de Documento Visualização',
  ROLE_MENU_GDT_ENVIO_GERENCIAMENTO: 'Envio de Documento Gerenciamento',

  ROLE_ACTION_GDT_LISTAGEM_MONITORAMENTO: 'Monitoramento de Documentos',
  ROLE_ACTION_GDT_LISTAGEM_VALIDADE: 'Controle de Validade',

  ROLE_MENU_GDT_AREA_DE_ATIVIDADE: 'Configurações - Área de atuação',
  ROLE_MENU_GDT_LINHAS_SERVICO: 'Configurações - Linhas de Serviço',
  ROLE_MENU_GDT_TIPOS_DOCUMENTOS: 'Configurações - Tipos de documentos',

  ROLE_ACTION_GDT_CNO_VISUALIZACAO: 'Cadastro de Obras (CNO) - Visualização',
  ROLE_ACTION_GDT_CNO_EDICAO: 'Cadastro de Obras (CNO) - Edição',

  ROLE_MENU_GDT_NOTIFICACOES: 'Listagem de Notificações',
  ROLE_ACTION_GDT_GERENCIAMENTO_NOTIFICACOES: 'Gerenciamento de Notificações',
  ROLE_ACTION_GDT_LISTAGEM_CATEGORIAS: 'Listagem de Categorias',
  ROLE_ACTION_GDT_GERENCIAMENTO_CATEGORIAS: 'Gerenciamento de Categorias',
  ROLE_ACTION_GDT_GERENCIAMENTO_AGENDAMENTO_AUTOMATICO: 'Agendamento Automático',
};

export const USER_ROLE_GROUPS = [
  {
    key: 'terceiros',
    title: 'Terceiros',
    roles: [
      'ROLE_MENU_GDT_LISTAGEM',
      'ROLE_ACTION_GDT_LISTAGEM_EDICAO',
      'ROLE_MENU_GDT_FOLHA_PAGTO',
      'ROLE_MENU_GDT_ENCARGOS',
    ],
  },
  {
    key: 'certidoes',
    title: 'Certidões',
    roles: ['ROLE_ACTION_GDT_LISTAGEM_CERTIDOES', 'ROLE_ACTION_GDT_GERENCIAMENTO_CERTIDOES'],
  },
  {
    key: 'trabalho-analogo',
    title: 'Trabalho Análogo à Escravidão',
    roles: ['ROLE_ACTION_GDT_LISTAGEM_TRABALHO_ANALOGO', 'ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHO_ANALOGO'],
  },
  {
    key: 'trabalhadores-alocados',
    title: 'Trabalhadores Alocados',
    roles: ['ROLE_ACTION_GDT_LISTAGEM_TRABALHADORES_ALOCADOS', 'ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHADORES_ALOCADOS'],
  },
  {
    key: 'solicitacoes',
    title: 'Solicitações',
    roles: ['ROLE_MENU_GDT_SOLICITACAO_VISUALIZACAO', 'ROLE_MENU_GDT_SOLICITACAO_GERENCIAMENTO'],
  },
  {
    key: 'envio-documentos',
    title: 'Envio de Documentos',
    roles: ['ROLE_MENU_GDT_ENVIO_VISUALIZACAO', 'ROLE_MENU_GDT_ENVIO_GERENCIAMENTO'],
  },
  {
    key: 'monitoramento',
    title: 'Monitoramento',
    roles: ['ROLE_ACTION_GDT_LISTAGEM_MONITORAMENTO', 'ROLE_ACTION_GDT_LISTAGEM_VALIDADE'],
  },
  {
    key: 'configuracoes',
    title: 'Configurações',
    roles: ['ROLE_MENU_GDT_AREA_DE_ATIVIDADE', 'ROLE_MENU_GDT_LINHAS_SERVICO', 'ROLE_MENU_GDT_TIPOS_DOCUMENTOS'],
  },
  {
    key: 'cno',
    title: 'Cadastro de Obras (CNO)',
    roles: ['ROLE_ACTION_GDT_CNO_VISUALIZACAO', 'ROLE_ACTION_GDT_CNO_EDICAO'],
  },
  {
    key: 'notificacoes',
    title: 'Notificações',
    roles: [
      'ROLE_MENU_GDT_NOTIFICACOES',
      'ROLE_ACTION_GDT_GERENCIAMENTO_NOTIFICACOES',
      'ROLE_ACTION_GDT_LISTAGEM_CATEGORIAS',
      'ROLE_ACTION_GDT_GERENCIAMENTO_CATEGORIAS',
      'ROLE_ACTION_GDT_GERENCIAMENTO_AGENDAMENTO_AUTOMATICO',
    ],
  },
];

export default USER_ROLES;
